import Button from "@material-tailwind/react/Button";
import H4 from "@material-tailwind/react/Heading4";
import Label from "@material-tailwind/react/Label";
import React, { useEffect, useState } from 'react';
import Loader from "react-loader-spinner";
import { useParams } from "react-router";
import fullstackProjects from "../Constants/FullStackProjects";

const ProjectDetail = () => {
    const { id: projectId } = useParams();
    const [project, setProject] = useState({});

    useEffect(() => {
        setProject(fullstackProjects.find(project => project.id === parseInt(projectId)));
    }, [projectId]);

    if (!project) return (
        <div className="w-full min-h-screen flex justify-center items-center">
            <Loader
                type="Puff"
                color="#00BFFF"
                height={100}
                width={100}
                timeout={3000} //3 secs
            />
        </div>
    );
    return (
        <div className="w-full min-h-screen p-4">
            <div className="w-full my-8">
                <img className="lg:w-8/12 md:w-10/12 sm:w-full mx-auto" src={project?.imageLarge} alt=""></img>
            </div>
            <div className="w-full flex flex-col justify-start">
                <div className="w-full flex flex-col">
                    <H4 className='w-full' color="gray">{project?.name}</H4>
                    <div className="w-full flex flex-wrap justify-center mt-8">
                        {
                            project?.technologies?.map((tech, index) => <Label className="m-1" key={index} color="lightBlue">{tech}</Label>)
                        }
                    </div>
                    <div className="w-full my-8">
                        <div className="w-full flex flex justify-center">
                            <a href={project?.live} target="_blank" rel="noopener noreferrer" className="m-1"> <Button
                                color="lightBlue"
                                buttonType="outline"
                                size="sm"
                                rounded={false}
                                block={false}
                                iconOnly={false}
                                ripple="dark"

                            >
                                Live
                            </Button></a>
                            <a href={project?.client} target="_blank" rel="noopener noreferrer" className="m-1">  <Button
                                color="lightBlue"
                                buttonType="outline"
                                size="sm"
                                rounded={false}
                                block={false}
                                iconOnly={false}
                                ripple="dark"
                            >
                                Client
                            </Button></a>
                            <a href={project?.server} target="_blank" rel="noopener noreferrer" className="m-1"> <Button
                                color="lightBlue"
                                buttonType="outline"
                                size="sm"
                                rounded={false}
                                block={false}
                                iconOnly={false}
                                ripple="dark"
                            >
                                Server
                            </Button></a>

                        </div>
                    </div>
                    <div className="w-full flex flex-col items-start">
                        {
                            project?.bulletPoints?.map((point, index) => <li className="text-left text-gray-900 p-1 my-1 lg:text-xl md:text-base sm:text-sm list-disc" key={index} color="gray">
                                {point}
                            </li>)
                        }
                    </div>
                </div>
                <p className="lg:text-3xl md:text-2xl sm:text-xl text-black font-bold">Screenshots</p>
                <div className='w-full mt-8 grid grid-cols-1 gap-4'>
                    {
                        project?.screenShots?.map((screenshot, index) => {
                            return <img key={index} className="w-10/12 mx-auto shadow-lg" src={screenshot} alt="" />
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default ProjectDetail;